var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCalendar = function SvgCalendar(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "calendar",
    width: 18.31,
    height: 18.31,
    viewBox: "0 0 18.31 18.31",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_84",
    "data-name": "Group 84"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_83",
    "data-name": "Group 83"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M16.165,1.431h-.858V0H13.876V1.431H4.435V0H3V1.431H2.146A2.148,2.148,0,0,0,0,3.576V16.165A2.148,2.148,0,0,0,2.146,18.31H16.165a2.148,2.148,0,0,0,2.146-2.146V3.576A2.148,2.148,0,0,0,16.165,1.431Zm.715,14.734a.716.716,0,0,1-.715.715H2.146a.716.716,0,0,1-.715-.715V6.723H16.88Zm0-10.872H1.431V3.576a.716.716,0,0,1,.715-.715H3V4.292H4.435V2.861h9.441V4.292h1.431V2.861h.858a.716.716,0,0,1,.715.715Z",
    fill: "#586682"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_86",
    "data-name": "Group 86",
    transform: "translate(2.317 8.803)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_85",
    "data-name": "Group 85",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    width: 2,
    transform: "translate(-0.317 0.094)",
    fill: "#586682"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_88",
    "data-name": "Group 88",
    transform: "translate(6.372 8.803)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87",
    "data-name": "Group 87",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35",
    "data-name": "Rectangle 35",
    transform: "translate(-0.372 0.094)",
    fill: "#586682"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_90",
    "data-name": "Group 90",
    transform: "translate(8.689 8.803)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    "data-name": "Group 89",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36",
    "data-name": "Rectangle 36",
    transform: "translate(0.311 0.094)",
    fill: "#586682"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_92",
    "data-name": "Group 92",
    transform: "translate(11.585 8.803)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    "data-name": "Group 91",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37",
    "data-name": "Rectangle 37",
    width: 1,
    transform: "translate(0.415 0.094)",
    fill: "#586682"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_94",
    "data-name": "Group 94",
    transform: "translate(13.902 8.803)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    "data-name": "Group 93",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38",
    width: 1,
    transform: "translate(0.098 0.094)",
    fill: "#586682"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_96",
    "data-name": "Group 96",
    transform: "translate(2.317 11.699)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_95",
    "data-name": "Group 95",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39",
    "data-name": "Rectangle 39",
    width: 2,
    height: 1,
    transform: "translate(-0.317 0.198)",
    fill: "#586682"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_98",
    "data-name": "Group 98",
    transform: "translate(6.372 11.699)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_97",
    "data-name": "Group 97",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40",
    "data-name": "Rectangle 40",
    height: 1,
    transform: "translate(-0.372 0.198)",
    fill: "#586682"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_100",
    "data-name": "Group 100",
    transform: "translate(8.689 11.699)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_99",
    "data-name": "Group 99",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41",
    "data-name": "Rectangle 41",
    height: 1,
    transform: "translate(0.311 0.198)",
    fill: "#586682"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_102",
    "data-name": "Group 102",
    transform: "translate(11.585 11.699)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_101",
    "data-name": "Group 101",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_42",
    "data-name": "Rectangle 42",
    width: 1,
    height: 1,
    transform: "translate(0.415 0.198)",
    fill: "#586682"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_104",
    "data-name": "Group 104",
    transform: "translate(2.317 14.016)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_103",
    "data-name": "Group 103",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43",
    "data-name": "Rectangle 43",
    width: 2,
    height: 1,
    transform: "translate(-0.317 -0.119)",
    fill: "#586682"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_106",
    "data-name": "Group 106",
    transform: "translate(6.372 14.016)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_105",
    "data-name": "Group 105",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_44",
    "data-name": "Rectangle 44",
    height: 1,
    transform: "translate(-0.372 -0.119)",
    fill: "#586682"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_108",
    "data-name": "Group 108",
    transform: "translate(8.689 14.016)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_107",
    "data-name": "Group 107",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_45",
    "data-name": "Rectangle 45",
    height: 1,
    transform: "translate(0.311 -0.119)",
    fill: "#586682"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_110",
    "data-name": "Group 110",
    transform: "translate(11.585 14.016)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_109",
    "data-name": "Group 109",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_46",
    "data-name": "Rectangle 46",
    width: 1,
    height: 1,
    transform: "translate(0.415 -0.119)",
    fill: "#586682"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_112",
    "data-name": "Group 112",
    transform: "translate(13.902 11.699)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_111",
    "data-name": "Group 111",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_47",
    "data-name": "Rectangle 47",
    width: 1,
    height: 1,
    transform: "translate(0.098 0.198)",
    fill: "#586682"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendar, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };